import { render } from "./ForumProject.vue?vue&type=template&id=46416b1e&scoped=true"
import script from "./ForumProject.vue?vue&type=script&lang=js"
export * from "./ForumProject.vue?vue&type=script&lang=js"

import "./ForumProject.vue?vue&type=style&index=0&id=46416b1e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46416b1e"]])

export default __exports__